import { graphql, useQuery } from "@opensea/graphql";
import { originalURL } from "@opensea/seadn";
import { ImageStack } from "@opensea/ui-kit";
import { withSuspense } from "../suspense/WithSuspense";
const query = graphql(`
  query EmptyStateImageStackQuery {
    topCollections(limit: 3, sort: { by: ONE_DAY_VOLUME, direction: DESC }) {
      items {
        previewItems(limit: 1) {
          imageUrl
        }
      }
    }
  }
`);
const solanaImageUrls = [originalURL("https://raw2.seadn.io/solana_default_nfts/clayno_8209.png"), originalURL("https://raw2.seadn.io/solana_default_nfts/fox.png"), originalURL("https://raw2.seadn.io/solana_default_nfts/main_smb.png")];
export const EmptyStateImageStack = withSuspense(function EmptyStateImageStack({
  isSolanaProfile
}) {
  const [{
    data
  }] = useQuery({
    query
  });
  const imageUrls = isSolanaProfile ? solanaImageUrls : data?.topCollections.items.flatMap(collection => collection.previewItems?.map(item => item.imageUrl)).filter(Boolean);
  return <ImageStack animate="fade-in" srcs={imageUrls} />;
});